<template>
    <div class="layout-container flex">

        <vertical-nav
                :position="navPos"
                :collapse-nav="collapseNav"
                :open-sidebar.sync="openSidebar"
                @collapse-nav-toggle="collapseNav = !collapseNav"
                @push-page="closeSidebar"
                v-if="navPos === 'left'"/>

        <div class="container flex column box grow">

            <div class="header" v-if="toolbar === 'top'">
                <Toolbar @toggle-sidebar="openSidebar = !openSidebar" :menu-burger="navPos"/>
            </div>
            <div class="header" v-if="toolbar === 'bottom'">
                <Toolbar @toggle-sidebar="openSidebar = !openSidebar" :menu-burger="navPos"/>
            </div>

            <div class="main box grow flex">
                <span class="main-out-border--top-left" v-if="roundedCorners"></span>
                <span class="main-out-border--top-right" v-if="roundedCorners"></span>
                <span class="main-out-border--bottom-left" v-if="roundedCorners"></span>
                <span class="main-out-border--bottom-right" v-if="roundedCorners"></span>
                <transition :name="viewAnimation" mode="out-in">
                    <router-view class="view box grow"/>
                </transition>
            </div>


        </div>

        <vertical-nav
                :position="navPos"
                :collapse-nav="collapseNav"
                :open-sidebar.sync="openSidebar"
                @collapse-nav-toggle="collapseNav = !collapseNav"
                @push-page="closeSidebar"
                v-if="navPos === 'right'"/>


    </div>
</template>


<script>
    import {detect} from 'detect-browser'

    const browser = detect()
    // @ is an alias to /src
    import VerticalNav from '@/core/vertical-nav.vue'
    import Toolbar from '@/core/toolbar.vue'

    export default {
        name: 'App',
        data() {
            return {
                collapseNav: false,
                openSidebar: false,
                innerWidth: 0
            }
        },
        computed: {
            navPos() {
                if (this.innerWidth <= 768 && (this.$store.getters.navPos === 'top' || this.$store.getters.navPos === 'bottom')) {
                    return 'left'
                }
                return this.$store.getters.navPos
            },
            toolbar() {
                return this.$store.getters.toolbar
            },

            boxed() {
                return this.$store.getters.boxed
            },
            roundedCorners() {
                return this.$store.getters.roundedCorners
            },
            viewAnimation() {
                return this.$store.getters.viewAnimation || 'none'
            },
            isLogged() {
                return this.$store.getters.isLogged
            },
            splashScreen() {
                return this.$store.getters.splashScreen
            }
        },
        methods: {
            resizeOpenNav() {
                this.innerWidth = window.innerWidth
                if (window.innerWidth <= 768) {
                    this.collapseNav = false
                }
            },
            closeSidebar() {
                this.openSidebar = false
            }
        },
        components: {
            VerticalNav,
            Toolbar,
        },
        created() {
            if (browser.name)
                document.getElementsByTagName("html")[0].classList.add(browser.name)
        },
        mounted() {
            this.resizeOpenNav()
            window.addEventListener('resize', this.resizeOpenNav);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.resizeOpenNav);
        }
    }
</script>

<style lang="scss">
    @import './assets/scss/_variables';
    @import './assets/scss/_mixins';

    .layout-container {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden;
        background: $background-color;

        .container {
            overflow: hidden;

            .header {
                height: 60px;
                background: $vertical-navbar-logo-backround;
                box-sizing: border-box;
                padding-bottom: 15px;
                padding-top: 15px;
                padding-left: 30px;
                padding-right: 30px;
            }

            .main {
                position: relative;
                overflow: hidden;
                padding: 0 30px;
            }

            .view {
                padding: 20px;
                padding-bottom: 10px;
                padding-top: 0px;
                box-sizing: border-box;
                transition: all .4s cubic-bezier(.55, 0, .1, 1);
                backface-visibility: hidden;
                /*-webkit-perspective: 1000px;*/

            }

            .fade-top-in-out-enter {
                opacity: 0;
                transform: translate(0, 30px);
            }

            .fade-top-in-out-leave-active {
                opacity: 0;
                transform: translate(0, 30px);
            }

            .fade-top-enter {
                opacity: 0;
                transform: translate(0, 30px);
            }

            .fade-top-leave-active {
                opacity: 0;
                transform: translate(0, -30px);
            }

            .fade-bottom-in-out-enter {
                opacity: 0;
                transform: translate(0, -30px);
            }

            .fade-bottom-in-out-leave-active {
                opacity: 0;
                transform: translate(0, -30px);
            }

            .fade-bottom-enter {
                opacity: 0;
                transform: translate(0, -30px);
            }

            .fade-bottom-leave-active {
                opacity: 0;
                transform: translate(0, 30px);
            }

            .fade-left-enter {
                opacity: 0;
                transform: translate(30px, 0);
            }

            .fade-left-leave-active {
                opacity: 0;
                transform: translate(-30px, 0);
            }

            .fade-right-enter {
                opacity: 0;
                transform: translate(-30px, 0);
            }

            .fade-right-leave-active {
                opacity: 0;
                transform: translate(30px, 0);
            }

            .fade-enter {
                opacity: 0;
            }

            .fade-leave-active {
                opacity: 0;
            }


            .main-out-border {
                &--top-left, &--top-right {
                    background: linear-gradient($background-color, rgba(230, 235, 241, 0));
                    height: 16px;
                    position: absolute;
                    width: 8px;
                    z-index: 1;
                    top: 4px;
                }

                &--bottom-left, &--bottom-right {
                    background: linear-gradient(rgba(230, 235, 241, 0), $background-color);
                    height: 16px;
                    position: absolute;
                    width: 8px;
                    z-index: 1;
                    bottom: 4px;
                }

                &--top-left, &--bottom-left {
                    left: 42px;

                    &::after {
                        content: "";
                        height: 5px;
                        position: absolute;
                        right: -4px;
                        top: -4px;
                        width: 12px;
                        box-shadow: 8px 0px 0px 0px $background-color inset;
                        border-top-left-radius: 5px;
                    }
                }

                &--top-right, &--bottom-right {
                    right: 42px;

                    &::after {
                        content: "";
                        height: 5px;
                        left: -4px;
                        position: absolute;
                        top: -4px;
                        width: 12px;
                        box-shadow: -8px 0px 0px 0px $background-color inset;
                        border-top-right-radius: 5px;
                    }
                }

                &--bottom-left:after {
                    border-radius: 0;
                    border-bottom-left-radius: 5px;
                }

                &--bottom-right:after {
                    border-radius: 0;
                    border-bottom-right-radius: 5px;
                }

                &--bottom-left, &--bottom-right {
                    &::after {
                        top: initial;
                        bottom: -4px;
                    }
                }
            }

        }

        &.boxed {
            max-width: 1300px;
            margin: 0 auto;
            box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.15), 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
        }

        &.footer-above {
            padding-bottom: 40px;
            position: relative;
        }

        &.content-only {
            .container {
                .main-out-border--top-left, .main-out-border--top-right,
                .main-out-border--bottom-left, .main-out-border--bottom-right {
                    display: none;
                }
            }
        }
    }

    html:not(.ie) {
        .layout-container {
            .container {
                /*max-width: 1920px;*/
            }
        }
    }

    @media (min-width: 1920px) {
        .layout-container:not(.boxed) {
            &.column {
                .container {
                    margin: 0 auto;
                }
            }
        }
    }

    @media (max-width: 768px) {
        .layout-container {
            .container {
                /*width: 100%;
                max-width: 100%;
                height: 100%;
                max-height: 100%;*/

                .header {
                    height: 50px;
                    box-shadow: 0px -20px 10px 20px rgba(0, 0, 0, 0.25);
                    margin: 0;
                    margin-bottom: 5px;

                    .toggle-sidebar {
                        box-shadow: none !important;
                    }

                    .search-box {
                        & > .el-autocomplete {
                            box-shadow: none !important;
                        }
                    }
                }

                .main {
                    padding: 0 5px;
                }


                .view {
                    //padding: 5px;
                    max-width: 100%;
                    padding: 15px;
                }

                .main-out-border--top-left, .main-out-border--top-right,
                .main-out-border--bottom-left, .main-out-border--bottom-right {
                    display: none;
                }
            }
        }
    }


    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s ease-out;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }


    /*Taylan CSS*/
    .layout-container .container .main {
        position: relative;
        overflow: hidden;
        padding: 0 30px;
        background: #d0d0d0;
    }
    .flip-card-back{
        position: absolute;
        -webkit-transform: rotateY(-180deg) translateZ(1px);
        transform: rotateY(-180deg) translateZ(1px);
        top: 0;
        left: 0;
        min-height: 100%;
        width: 100%;
        height: auto;
        background: #fff;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
    }
    .el-tree-node.is-current > .el-tree-node__content {
        background: #0075c3 !important;
        color: #fff;
    }

    .ck-editor__editable {
        min-height: 200px;
    }

    .baslikBg {
        background: #0075c3;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }

    .resimler .el-icon-zoom-in:before {
        font-family: 'Material Design Icons';
        content: "\f796";
    }

    .el-row:first-child {
        margin-top: 10px;
    }

    .el-divider__text.is-left {
        font-weight: bold;
    }

    .el-form-item__label {
        line-height: 30px !important;
    }

    .el-form-item__content {
        line-height: 30px;
        position: relative;
        font-size: 14px;
    }

    .yanForm .card-base {
        margin-top: 15px;
        padding: 15px 15px 0 15px;
    }

    .yanForm .card-base:first-child {
        margin-top: 0;
    }

    .el-input .el-input--suffix .el-input__inner {
        width: 100px;
    }

    .searchClass {
        -webkit-appearance: none;
        background-color: #FFFFFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 30px;
        line-height: 30px;
        outline: none;
        padding: 0 15px;
        -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 100%;
    }

    .searchClass:focus {
        border-color: #005aca;
    }

    .el-tabs__header.is-left {
        position: absolute;
        left: -34px;
    }

    .language #tab-0 {
        margin-top: 30px;
        animation: 1s ease-out 0.3s fadeInRight;
    }

    .el-button label {
        cursor: pointer;
    }

    .language #tab-1 {
        margin-top: 5px;
        animation: 1.5s ease-out 0.3s fadeInRight;
    }
    .language #tab-2 {
        margin-top: 5px;
        animation: 2s ease-out 0.3s fadeInRight;
    }

    @keyframes fadeInRight {
        from {
            opacity: 0;
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }

        to {
            opacity: 1;
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    .language .el-tabs__item {
        background: rgba(93, 93, 93, 0.23);
        border-radius: 5px 0 0 5px;
        position: relative;
        right: -8px;
        transition: all 1s;
    }

    .language .el-tabs__item i {
        transition: transform 1s;
    }

    .language .el-tabs__item:hover {
        & i {
            transform: rotateY(360deg);
        }
    }

    .language .el-tabs__item.is-active {
        background: #0075c3;
        color: #fff;
        position: relative;
        right: 0;
    }

    .language .el-tabs__active-bar.is-left {
        display: none;
    }

    .language .el-tabs__nav-wrap.is-left::after {
        display: none;
    }

    .language .el-tabs__item.is-left {
        text-align: right;
    }

    .language .tr.el-tabs__item.is-left {
        text-align: right;
        background: #ec205f;
        border-radius: 2px;
    }

    .language .el-tabs__header.is-left {
        margin-right: 0 !important;
    }

    .language .el-tabs__item {
        padding: 0 10px;
    }


    .el-table__expanded-cell {
        background-color: #f5f5f5;
    }

    .layout-container .container .main {
        background: #d0d0d0;
    }

    .el-button--mini {
        padding: 5px 10px !important;
    }

    .el-button--info {
        color: #FFFFFF;
        background-color: #64b1e2;
        border-color: #64b1e2;
    }

    .el-button--info:hover {
        color: #FFFFFF;
        background-color: #64b1e2;
        border-color: #64b1e2;
    }

    .durdurBtn {
        background: #99abb4;
        border: 1px solid #99abb4;
        color: white;
    }

    .durdurBtn:hover {
        border: 1px solid #A2B3BC;
        color: white;
        background: #A2B3BC;
    }

    .mainDiv {
        .label-switch-box {
            display: block;
            clear: both;
            width: 100%;
            text-align: right;
            margin-bottom: 20px;
        }

        .col-p {
            margin: -5px 0;
            padding: 0 15px;
            box-sizing: border-box;
        }

        .select-wide {
            width: 100%;
        }
    }

    .el-button {
        font-size: 16px;
    }

    .el-form-item {
        font-weight: bold;
    }

    .mdi-information-outline::before {
        content: "\F2FD";
        color: #26c6da;
    }

    .onayBtn {
        margin-left: 17px;
        margin-bottom: 10px;
    }

    .el-collapse-item {
        margin-bottom: 10px;
        border-radius: 5px 5px 0 0;
    }

    .el-collapse {
        border-top: unset;
        border-bottom: unset;
    }
    .el-collapse-item__header {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        padding: 0 15px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        height: 48px;
        line-height: 48px;
        border-radius: 5px 5px 0 0;
        background-color: #FFFFFF;
        cursor: pointer;
        color: #303133;
        border-bottom: 1px solid #EBEEF5;
        font-size: 13px;
        font-weight: bold;
        -webkit-transition: border-bottom-color .3s;
        transition: border-bottom-color .3s;
        outline: none;
    }
    .el-collapse-item .el-row{
        position: relative;
        top: 15px;
    }
    .el-collapse-item__wrap {
        border-radius: 0 0 5px 5px;
    }
    .el-radio .is-checked .el-radio__label img{
        box-shadow: 5px 5px 10px 0px black;
    }
    .el-collapse-item__header.is-active {
        border-bottom-color: #f0f0f0;
    }
    .el-transfer-panel {
        border: 1px solid #EBEEF5;
        border-radius: 4px;
        overflow: hidden;
        background: #FFFFFF;
        display: inline-block;
        vertical-align: middle;
        width: 300px;
        height: 400px;
        max-height: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: relative;
    }
    .wizard__arrow{
        position: absolute;
        display: block;
        width: 30px;
        height: 30px;
        border: 1px solid #aebac4;
        top: 85px;
        border-top-right-radius: 5px;
        background-color: #f1f1f1 !important;
        border-left: none;
        border-bottom: none;
        transform: rotate(-45deg);
        z-index: 2;
        -webkit-transition: left 0.3s;
        -o-transition: left 0.3s;
        transition: left 0.3s;
    }
    .wizard__body__step {
        padding: 16px;
        background: #f1f1f1;
    }
    .wizardd .language .el-tabs__header.is-left {
        margin-right: 32px;
        position: absolute;
        left: -40px;
    }
    /*Ürün Tanımlama*/
    .el-transfer-panel__list.is-filterable {
        padding-top: 0;
    }
    .guncellemeTransfer .el-transfer__buttons {
        display: none;
        vertical-align: middle;
        padding: 0 30px;
    }
    .el-transfer-panel {
        border: 1px solid #EBEEF5;
        border-radius: 4px;
        overflow: hidden;
        background: #FFFFFF;
        display: inline-block;
        vertical-align: middle;
        width: 200px;
        height: 300px;
        max-height: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: relative;
    }
    .el-transfer-panel.first-child {
        margin-left: 20px;
    }
    /*Ürün Tanımlama*/


    @media (max-width: 768px) {
        .yanForm{
            margin-top: 10px;
        }
        .el-transfer-panel {
            border: 1px solid #EBEEF5;
            border-radius: 4px;
            overflow: hidden;
            background: #FFFFFF;
            display: inline-block;
            vertical-align: middle;
            width: 250px;
            height: 400px;
            max-height: 100%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            position: relative;
        }
        .el-transfer__buttons {
            transform: rotate(90deg);
            display: table;
            vertical-align: text-bottom;
            padding: 0 100px;
        }

    }
    @media (max-width: 1417px) {
        .el-transfer-panel {
            border: 1px solid #EBEEF5;
            border-radius: 4px;
            overflow: hidden;
            background: #FFFFFF;
            display: inline-block;
            vertical-align: middle;
            width: 250px;
            height: 400px;
            max-height: 100%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            position: relative;
        }
        .el-transfer__buttons {
            transform: rotate(90deg);
            display: table;
            vertical-align: text-bottom;
            padding: 0 100px;
        }

    }
    /*Taylan CSS*/


</style>
